// extracted by mini-css-extract-plugin
export default {"subNavLinks":"SubNavLinks__subNavLinks__tBlFW","subNavItem":"SubNavLinks__subNavItem__sNL99"};